import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-ivory font-sans text-ink" data-id="element-0" data-mp="28tmfp53igeya">
      <Hero data-id="element-1" data-mp="28s2y9b64bxux" />
      <main data-id="element-2" data-mp="23vci6nubd29i">
        <ProblemSection data-id="element-3" data-mp="23vuokdaowwv5" />
        <SolutionSection data-id="element-4" data-mp="23u9q4cl98ts0" />
        <VolumesSection data-id="element-5" data-mp="23v2tr4ox335x" />
        <BonusesSection data-id="element-6" data-mp="3ijxqiu0iq6lh" />
        <HowItWorksSection data-id="element-7" data-mp="3ikr002qv3a7b" />
        <OfferSection data-id="element-8" data-mp="3ijfwm41bw4gq" />
        <GuaranteeSection data-id="element-9" data-mp="3ihv0i9zd8dgr" />
        <TestimonialsSection data-id="element-10" data-mp="3mlaxx8j9ehui" />
        <FaqSection data-id="element-11" data-mp="3mkho1yp07c85" />
        <FinalCtaSection data-id="element-12" data-mp="3mjzpgvevclx2" />
      </main>
      <Footer data-id="element-13" data-mp="3rc9i4j7dc031" />
      <StickyCta data-id="element-14" data-mp="3rbrbqtqzs5he" />
    </div>;
}